import * as React from 'react';
import {ThemeProvider, createTheme} from '@mui/material/styles';
import {muiTheme} from '../styles/muiTheme';

interface AppThemeProps {
  children: React.ReactNode;
  /**
   * This is for the docs site. You can ignore it or remove it.
   */
  disableCustomTheme?: boolean;
}

export default function AppTheme(props: AppThemeProps) {
  const {children, disableCustomTheme} = props;
  const theme = React.useMemo(() => {
    if (disableCustomTheme) return undefined;
    return createTheme(muiTheme, {
      components: {},
    });
  }, [disableCustomTheme]);
  if (disableCustomTheme) {
    return <React.Fragment>{children}</React.Fragment>;
  }
  return (
    <ThemeProvider theme={theme!} disableTransitionOnChange>
      {children}
    </ThemeProvider>
  );
}
